import { ReactNode } from "react";

import { css } from "@compiled/react";

export const formatRegisteredSymbol = {
    sup: (chunks: ReactNode) => (
        <sup
            css={css({
                lineHeight: 0
            })}
        >
            {chunks}
        </sup>
    )
};
